// LocalStorage Keys Constants
export const LS_KEYS = {
  TOKEN: "token",
  OUTLET_ID: "outlet_id",
  OUTLET_NAME: "outlet_name",
  OUTLET_ID_CAMEL: "outletId",
  OUTLET_NAME_CAMEL: "outletName",
  SELLER_TYPE: "seller-type",
  PHONE_NUMBER: "phone_number",
  EMAIL: "email",
  USER_ID: "user_id",
  IS_NEW_SELLER_HUB_LOGIN_FLOW_ENABLED: "is_new_seller_hub_login_flow_enabled",
  PHONE_NUMBER_SIGNIN: "phone_number_signin",
  ROUTING_CONTEXT: "routingContext",
  REFERRER_PLATFORM: "referrer_platform",
  REFERRED_PLATFORM_TYPE: "referred_platform_type",
};
